<template>
	<div class="focusenterprises">
		<leftnav class="fl" :mkcode="'J'" :itemcode="curPage.itemcode" ></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox has-title-font" style="min-height: 300px;">    
					<div class="right_boxtitle">
						<span class="fl right_title  mt-1">{{curPage.title}}</span>
						<p class="fl titlefont" v-html="curPage.titlefont"></p>
						<div class="fl search-box">
							<span class="searchtype">本地企业关联的外地企业</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext" @keydown="searchenter"/>
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
						</div> 
						<div class="enterprise_list_box" >
							<div class="opport-screen-list1">
								<dl class="opport-screen bdbe">
									<dt class="fl">本省城市</dt>
									<dd class="fl"> 
										<span v-for="(item,index) in provinceData" :key="index" :class="calcuCityid == item.areaId?'a-screen current':'a-screen'" @click="provinceCityCalcu(item)">{{item.areaName}} </span>  
									</dd>
								</dl>  
								<dl class="opport-screen bdbe">
									<dt class="fl long-font">对应城市关系</dt>
									<dd class="fl">
										<span v-for="(item,index) in local_relationship" :key="index" :class="data_type == item.value?'a-screen current':'a-screen'" 
										@click="routerself('enterprisesCityRelation-province?type='+item.value);">{{trunCityType(item.title)}}<em class="num">({{item.num}})</em></span>  
									</dd>
								</dl> 
								<dl class="opport-screen bdbe">
									<dt class="fl long-font">外地关联城市</dt>
									<dd class="fl">
										<span :class="cityid == 0?'a-screen current':'a-screen'" @click="cityid=0;cityText='全国';getThirdRelationList()">全国地区</span>  
										<span v-for="(item,index) in cityData" :key="index" :class="cityid == item.areaId?'a-screen current':'a-screen'" @click="cityid=item.areaId;cityText=item.areaName;getThirdRelationList()">{{item.areaName}}<em class="num">({{item.num}})</em></span>  
									</dd>
								</dl> 
								<!-- 产业分类 --> 
								<notionScreen :type="1" :notionNumList='[]' :token="userdata.token" @chooseNotion="chooseNotion" :isShowNotionScreen="true"></notionScreen>
							</div>
							<div class="enterparise_guide oh" style="width: 100%; ">
								<div class="fl" >产业大脑为您找到<span class="searchnum">{{total}}</span>
									<em v-show="kwtextsearchtext !=''">【 <span class="orangefont">{{kwtextsearchtext}}</span>】</em> 条相关结果</div> 
								<!-- <div class="fr oh">
									<el-tooltip class="item smartTip-text" effect="light" placement="right-start">
										<i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
										<div slot="content" class="list_tips">
											<p>批量加入熟悉的企业： 将当前展示列表内的企业添加进熟悉企业列表</p> 
										</div>
									</el-tooltip>
									<div class="fl enlistexportbtn" style="margin-left: 180px;">
										<span style="width: 180px;" @click="batchAddEnterpriseRelation()">批量加入熟悉的企业</span> 
									</div> 
								</div>  -->
							</div>
							<div class="enterprise_list_box" > 
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
									<tr> 
										<th style="width:10px;padding:0;">排名</th>
										<th>{{cityText}}关联企业</th>
										<th style="width:10px;padding:0;">城市</th>
										<th>{{calCuData.text}}关联企业</th>
										<th v-show="isShowTh">{{trunThType(data_type)}}</th>
										<th>操作</th> 
									</tr>
									<tr v-for="(list,i) in thirdCompanyList" :key="i"  v-if="i<thirdCompanyNum">
										<td style="width:10px;padding:0;">{{(page-1)*pageSize+i+1}}</td>
										<td class="title" @click="routerlinkid('/enterprises',list.stockCode)" v-if="list.rowspan>0" :rowspan="list.rowspan">{{list.title}}</td>
										<td style="width:10px;padding:0;">{{list.areaName}}</td>
										<td >
											<p v-for="(item,chii) in list.localEnterprise" :key="chii" class="curp-a" @click="routerlinkid('/enterprises',item.stockCode)" v-show="chii<10 || list.showmore">{{item.title}}</p>
											<p v-if="list.localEnterprise.length>10" class="curp" @click="list.showmore=!list.showmore">{{list.showmore?'隐藏':'查看更多'}}</p>
										</td>
										<td v-show="isShowTh"><span class="curs-pointer curp-a" @click="routerlinkid(middleRouter,list.middleId)" v-show="list.middleName != ''">{{list.middleName }}</span><span v-show="list.middleName == ''">-</span></td>
										<td class="collectfont1"> 
											<!-- <span class="bde" v-show="list.enterpriseRelationType!=2" :data="list.enterpriseRelationId" @click="toggleRelationEnterprise(list,1)">{{list.enterpriseRelationId > 0?'移除':'加入'}}我熟悉的企业</span> -->
											<span class="bde" @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}目标企业</span>
											<span :data="list.crmId" @click="crmtoggle(list,list.stockCode)">{{list.crmId ==0?'加入':'移除'}}项目管理</span> 
										</td>
									</tr>
								</table> 
								<freeUserTips :type="1" :bgtype="16" v-if="thirdCompanyList.length>2 && isFree"></freeUserTips>
							</div>
							<div class="centerpage1 company_pagelist" v-show="totalPage>1">
								<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="getThirdRelationList"></zpagenav>
							</div>
						</div>  
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
	import { mapState, mapMutations, mapGetters } from "vuex";
	import { dataInJs } from "../../utils/city.js";
	
	export default {
		name: 'enterprisesCityRelation-province',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: "本省关系计算器独立 如果这里改了 要去企业城市计算器改",
				cityText:"全国",
				userdata: {token:"",currentCity:{type:"city"}},
				curWebsite:this.$api.getWebsiteType(),  
				calCuData:{},  
				secondaryList: [],
				secondaryNameList:[],
				secondaryEmptyText:"",
				thirdCompanyList:[],
				iscache:true, 
				page: 1, //显示的是哪一页 
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数     
				RelatedList: [], //企业触达线索表格
				oneNameList: "", //一级线索里已有的企业名字  
				curPage:{label:"全部",value:0,num:0,itemcode:"J-QB",title:"",titlefont:""},
				local_relationship:[
					// {label:"全部",value:0,num:0,itemcode:"J-QB",title:"",titlefont:""},
					{label:"该市企业的股东",value:1,num:0,itemcode:"J-GD",title:"本地企业外地股东",titlefont:"某家外地龙头企业，可能是本市某家企业的股东，但您未必知道；这里给您全部呈现。<br>让有股权投资关系的企业相互介绍，成功的概率会非常高，是以商招商的重要途径。"},
					{label:"该市企业的对外投资",value:2,num:0,itemcode:"J-DWTZ",title:"本地企业对外投资",titlefont:"某家外地龙头企业，可能本市某家企业有投资过它，我们把这种投资关系全部挖掘出来。<br>让有股权投资关系的企业相互介绍，成功的概率会非常高，是以商招商的重要途径。"},
					{label:"该市企业的供应商",value:3,num:0,itemcode:"J-GYS",title:"本地企业的外地供应商",titlefont:"围绕本地龙头企业招引上下游，一直都是政府产业链招商、以商招商的最基本思路。<br>这里把本地龙头企业的供应商挖掘出来、全面呈现，是您以商招商的重要线索。"},
					{label:"该市企业的客户",value:4,num:0,itemcode:"J-KH",title:"本地企业的外地客户",titlefont:"如果本地企业是外地公司的重要客户，那么通过本地企业介绍，对方一定会给面子。<br>这里把外地重点企业的本地客户都挖掘出来，所以是政府以商招商的重要线索。"},
					// {label:"在该市有拿地的企业",value:5,num:0,itemcode:"J-NDQY",title:"",titlefont:""}, 
					{label:"相同投资机构的企业",value:6,num:0,itemcode:"J-TZJG",title:"相同投资机构下的外地企业",titlefont:"外地的目标企业，与本市的某家企业有共同的投资机构，这是一种有效的间接关系。<br>让本地企业介绍认识的投资机构，再请投资机构介绍认识的目标企业，也算是以商招商。"}, 
					// {label:"相同商会的企业",value:7,num:0,itemcode:"J-SH",title:"",titlefont:""}, 
					// {label:"相同协会的企业",value:8,num:0,itemcode:"J-XH",title:"",titlefont:""}, 
				],//关系类型 1=股东, 2=子公司, 3=供应商, 4=客户, 5=拿地,6=投资机构, 7=商会, 8=协会
				data_type:0,
				cityTotalNum:20,
				cityData:[],
				cityid:0, 
				//20231122新增本省关系计算器相关内容
				notionCode:'',
				countryData:dataInJs(), 
				provinceData:[],
				calcuCityid:0,
				calcuCityType:'省',
				searchtext: "",
				kwtextsearchtext: "",
				isShowTh:false,
				middleRouter:'',
				relationData:[],
				thirdCompanyNum:0,
			}
		},
		created() {
			this.userdata = this.getuseriformation();
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			
		},
		watch: {
			$route: function(newVal, oldVal) {   
				this.getCurPage()
			}
		},
		components: {
		 freeUserTips
		},
		mounted() {
			
			this.getCurPage(); 
			document.getElementById('app').style.background = "#f0f3f5"; 
			this.provinceData=this.countryData.filter(list=>{
				return list.areaId==this.userdata.province;
			});
			this.calcuCityid=this.userdata.city;
			this.provinceData=this.provinceData[0].children; 
   this.calCuData=this.getCalcuCity(this.userdata); 
			// this.getEnterpriseRelated(1)
			// this.showRelationScreen();
		},
		methods: {
			//概念单选 层级显示
			chooseNotion(chooseNotionlist,notionCode){ 
				this.notionCode=notionCode; 
				this.getThirdRelationList(1);
			},
			//获取当前页面的类型信息
			getCurPage(){
				this.data_type = this.$route.query.type ? this.$route.query.type : 1; 
				var type=this.data_type;
				let arry=this.local_relationship.filter(list=>{
					return list.value == type;
				}); 
				this.curPage=arry[0];
				this.isShowThComp(this.data_type);
				// this.refreshCity++;  
				this.getThirdRelationList(1);
			},
			//商会协会的跳转链接
			isShowThComp(data_type){
				this.isShowTh = this.data_type == 6 || this.data_type == 7 || this.data_type == 8;
				if(this.data_type == 6){
					this.middleRouter = '/investement-enterprises';
				}else if(this.data_type == 7){
					this.middleRouter = '/commerceDetail';
				}else if(this.data_type == 8){
					this.middleRouter = '/associationDetail';
				}
				// console.log('是否显示相同机构等',this.isShowTh,this.middleRouter);
				// return this.isShowTh;
			},
			//关系表的数字存值
			setRelationNum(data){
				this.local_relationship.forEach(list=>{
					var types=list.value;
					data.forEach(item=>{
						var types1=item.dataType;
						if(types == types1){
							list.num=item.num;
						}
					})
				})
			},
			//搜索关键词 
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
				this.getThirdRelationList();
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			//转换表格相同协会、机构、商会表头名
			trunThType(type){
				 if(type == 6){
					return '相同机构';
				 }else if(type == 7){
					return '相同商会';
				 }else if(type == 8){
					return '相同协会';
				 }else{
					return '不在列表';
				 }
			},
			trunCityType(text){
				 if(this.calcuCityType == '省'){
						return text.replace('本市','该市');
					}else{
						return text.replace('该市','本市');
					}
			},
			//本省关系计算器和本市关系计算器相互切换
			toggleType(type){
				this.calcuCityType=type; 
				if(this.calcuCityType == '省'){
					if(this.userdata.groupType == 0){
						return;
					}else{
						//跑执行本省关系计算器代码
					}
				}else if(this.calcuCityType == '市'){
					this.calcuCityid=this.userdata.city;
				};
				this.getThirdRelationList(1);
			},
		//关联的外地企业
		showRelationScreen(){ 
			if(this.thirdCompanyList.length<1){
				this.getThirdRelationList(1);
			}
		},
		//本省关系计算器城市
		provinceCityCalcu(item){
			console.log('-----',item,this.calCuData );
			this.calcuCityid=item.areaId;
			this.calCuData = item;
			this.calCuData.text = item.areaName;
			this.getThirdRelationList(1);
			
		},
		//本市关系计算器使用
			getThirdRelationList(page){ 
				if(this.userdata.isFree && page > 1 ){
					this.$message({type:'warning',message:"本账号试用期已截止,如需延期请即刻与我们联系"});
					return;
				}; 
				var that=this;
				this.page=page?page:1;
				this.bus.$emit('loading', true);
				// var datatype=this.splicing('dataType',this.data_type);
				// var cityn=this.splicing('city',this.cityid); 
				// var usercityn= this.splicing('userCity',this.calcuCityid);/* 本地只有vip001才有数据 */
				// var kwaja = this.splicing('kw', this.searchtext);
				// var ajaxurl=this.$api.cyl.enterpriseCityRelation.list() + '?page='+this.page+datatype+cityn+usercityn+kwaja;
				let queryData={dataType:this.data_type,city:this.cityid,userCity:this.calcuCityid,kw:this.searchtext,page:this.page,notionCode:this.notionCode };
				var ajaxurl=this.$api.cyl.enterpriseCityRelation.list(queryData); 
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('关联的外地企业',ajaxurl,res.data)
					if (res.data.success) {
					 that.cityData=res.data.cityList;
						that.relationData=res.data.data;
						that.setRelationNum(res.data.data);
						let totalnum=0;
						for(var i=0;i<res.data.cityList.length;i++){
							totalnum+=res.data.cityList[i].num;
						}; 
						res.data.list.forEach(list=>{
							list.showmore=false;
							list.rowspan=1;
						});
						
						// if(that.data_type > 5){
						// 	that.thirdCompanyList=that.mergeSameCompanyName(res.data.list);
						// }else{
							that.thirdCompanyList=res.data.list;
						// }
						that.cityTotalNum=totalnum; 
						that.totalPage = res.data.totalPage;
						that.pageSize = res.data.pageSize;
						that.total = res.data.totalRecord;
						that.kwtextsearchtext = that.searchtext; 
						that.thirdCompanyNum=that.userdata.isFree ? 3 : that.thirdCompanyList.length;
						that.bus.$emit('loading', false);
					}
				}).catch(function(error) {}); 
			}, 
			//相同投资机构和相同协会商会部分的关联企业会重合 需要合并展示
			mergeSameCompanyName(datalist){
				var copyData=datalist;
				var lastData=[];
			 for(var i=0;i<datalist.length;i++){
					let name1=datalist[i].title;
					if(datalist[i].rowspan > 0 ){
						lastData.push(datalist[i]);
						for(var d=1;d<copyData.length;d++){
							let name2=copyData[d].title; 
							if(name1 == name2 &&  i!= d ){
								datalist[i].rowspan++;
								datalist[d].rowspan=0;
								lastData.push(datalist[d]);
							}
						}
					}
					
				} 
				return lastData;
			},
			//加入移除项目管理
			crmtoggle(data,enterpiseid){ 
				var that=this;  
				if(data.crmId ==0){ 
				this.$axios.get(this.$api.crm.enterprise.addtoCRM()+"?stockCode="+enterpiseid,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log("添加到CRM库",res);   
					if(res.data.success){  
							data.crmId = res.data.data.id; 
							that.$message({
								type: 'success',
								message: '已加入项目管理',
							});
					} 
				}).catch(function (error) {});
				}else{
					 console.log('移除',data.crmId)
					$.ajax({
						type:"POST",
						url:this.$api.crm.customer.delete(),
						data:{id:data.crmId}, 
						headers:{AuthToken:this.userdata.token },
						success:function(res){  
							if(res.success){
								data.crmId = 0; 
								that.$message({
									type: 'success',
									message: '已移除项目管理',
								});
							}else{
								that.$message({type:"error",message:res.msg})
							}
						} 
					}) 
				}
			},
			//批量添加我熟悉的企业
			batchAddEnterpriseRelation(){
				var data1=[],that=this;
			 this.thirdCompanyList.forEach(list=>{
					if(list.enterpriseRelationId == 0){
						data1.push(list.stockCode);
					}
				});
				let batchCode=data1.join(',');
				if(data1.length<1){
					return;
				};
				var	ajaxurl=this.$api.cyl.enterpriseRelation.addEnterprise(),ajaxdata={stockCode:batchCode,type:1};
			 $.ajax({
			 	type:"POST",
			 	url:ajaxurl,
			 	data:ajaxdata,
			 	headers:{AuthToken:this.userdata.token },
			 	success:function(res){  
			 		var msgtext='';
			 		console.log('已批量加入我熟悉的企业',res)
			 		if(res.success){ 
			 			msgtext='已批量加入我熟悉的企业';
							that.getThirdRelationList(that.page);
			 		}else{ 
			 			msgtext=res.msg;
			 		} 
			 		that.$message({
			 			type: res.success?'success':'error',
			 			message: msgtext,
			 		});
			 	} 
			 }) 
			}, 
			getcacheRelatedlist(cluetype){
					this.getEnterpriseRelated(1).then(res=>{ //需要等一级关系执行完成后再执行二级关系
						console.log(res);
					this.getLevel2List('cache');

					})
			},
			//获取企业触达线索 二级线索 type=calcu 新计算 type=cache初始拿缓存
			getLevel2List(type,enterpriseName,stockcode){
				this.bus.$emit('loading', true);
				var that = this; 
				var usercityn= this.splicing('userCity',this.calcuCityid);/* 本地只有vip001才有数据 */
				var ajaxurl=this.$api.cyl.collect.enterpriseRelatedLevel2();
				var namelist=[],nametext=""; 
				for(var i=0;i<this.secondaryNameList.length;i++){  
						namelist.push(this.secondaryNameList[i].stockCode)
					}
				if(type == 'cache'){
					nametext=namelist.join(',');
					ajaxurl=ajaxurl+'?cache='+nametext+usercityn;
					
				}else{
					ajaxurl=ajaxurl+ '?stockCode=' + stockcode+usercityn ;
				}  
				
				this.$axios.get(ajaxurl , {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('获取二级企业作战线索',ajaxurl,res.data);
					let reslist = res.data.list?res.data.list:[];  
					if(reslist.length>0){
						that.handleRelatedList(reslist, 2);
						that.secondaryEmptyText="计算结果";
					}else{
						if(type == 'cache'){
							that.secondaryList=[]; 
						}else if(type == 'calcu'){ 
							var list={title:enterpriseName,stockCode:stockcode,children:[]};
								that.secondaryList.push(list);
						}  
					} 
					that.bus.$emit('loading', false);
				
				})
			},
			//获取企业作战一级线索
			getEnterpriseRelated(level, pages) {
				return new Promise((resolve, reject) => {
				this.bus.$emit('loading', true); 
				this.page = pages ? pages : 1;
				var that = this; 
				var usercityn= this.splicing('userCity',this.calcuCityid);/* 本地只有vip001才有数据 */
				this.$axios.get(this.$api.cyl.collect.enterpriseRelated() + '?page=' + this.page + '&level=' + level+  usercityn, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('获取企业作战线索',that.$api.cyl.collect.enterpriseRelated() + '?page=' + that.page + '&level=' + level+  usercityn, res.data);
					let reslist = res.data.list?res.data.list:[];
					that.handleRelatedList(reslist, level);
					resolve('请求一级作战线索成功');
					that.bus.$emit('loading', false); 
				})
			})
			},
			
			//处理企业触达线索数据 
			handleRelatedList(datalist, level) {
				if (level == 1) {
					// console.log(datalist) 
							this.secondaryNameList=datalist.filter(list=>{
								return list.num==0;
							})
							if(this.secondaryNameList.length==0){
								this.secondaryEmptyText="暂无二级关系企业列表";
							}
					datalist=datalist.filter(list=>{
						return list.num>0;
					})  
					datalist=this.getDataName(datalist); 
				 var	oneNameList = "";
					for (var i = 0; i < datalist.length; i++) {
						oneNameList = oneNameList += '&' + datalist[i].title;
					}
						let exdata = [];
					for (var i = 0; i < datalist.length; i++) {
						// if (!datalist[i].isempty) {
							
							let smlist = {
								title: datalist[i].title,
								stockCode: datalist[i].stockCode,
								grade: 1,
								rowspan: 1,
								relationship: 'a',
								smtitle: "",
								smstockCode: 0,
								phone: "a",
								address: "a",
								isCounty:0,
							};
							let rowspannum = 0;
							for (var d = 0; d < datalist[i].children.length; d++) {
								let culist = datalist[i].children[d].list;
								smlist.relationship = datalist[i].children[d].relationship;
								for (var s = 0; s < culist.length; s++) {
									var isfirst = d == 0 && s == 0;
									if (!isfirst) {
										smlist.grade = 2;
									}
									// console.log(d,s,d == 0 && s == 0,smlist.grade)
									rowspannum++;
								// console.log('culist-----',culist[s].middleList);

									smlist.smtitle = culist[s].title;
									smlist.smstockCode = culist[s].stockCode;
									smlist.phone = culist[s].phone;
									smlist.address = culist[s].address;
									smlist.rowspan = rowspannum;
									smlist.grade = isfirst ? 1 : 2;
									smlist.isCounty=culist[s].isCounty;
									let ddd = smlist;
									// console.log('smdata-----',smlist)
									exdata.push({
										title: datalist[i].title,
										stockCode: datalist[i].stockCode,
										grade: isfirst ? 1 : 2,
										rowspan: datalist[i].rowspanum,
										relationship: datalist[i].children[d].relationship,
										smtitle: culist[s].title,
										smstockCode: culist[s].stockCode,
										phone: culist[s].phone,
										address: culist[s].address,
										isCounty:culist[s].isCounty,
										middleList:culist[s].middleList,//机构、协会、商会之才有数据其他为 []
									})
								}
							}
						// }
					} 
					this.oneNameList = oneNameList;
					this.RelatedList = exdata;
				} else if (level == 2) {
					// let onelist = this.oneNameList;  
					// datalist = datalist.filter(list => {
					// 	return onelist.indexOf(list.title) < 0 && list.num>0;
					// })
					console.log('二级计算',datalist,'-----',this.secondaryNameList);
					for(var d=0;d<this.secondaryNameList.length;d++){ 
						for(var i=0;i<datalist.length;i++){ 
							// console.log(this.secondaryNameList[d].stockCode,datalist[i].stockCode);
								if(this.secondaryNameList[d].stockCode == datalist[i].stockCode){
									console.log(this.secondaryNameList[d].title);
										this.secondaryNameList[d].iscache=true;
								}
							}
					}
					
					datalist=this.getDataName(datalist);
					console.log('二级计算---',datalist,'-----',this.secondaryNameList);
					for(var i=0;i<datalist.length;i++){
						let smdata=datalist[i].children;
						for(var d=0;d<smdata.length;d++){
							let smmdata=smdata[d].list;
							smdata[d].list=this.getDataNameL2(smmdata,'l2'); 
						}
					} 
					
					// console.log('二级线索1遍历', datalist);
     this.secondaryList=this.secondaryList.concat(datalist);
					console.log('二级线索列表遍历',this.secondaryList)
				}
				this.bus.$emit('loading', false);
			},
			getDataNameL2(datalist){
				//第二级和第一级格式不同
				for(var i=0;i<datalist.length;i++){
					datalist[i].children=[];
					var onelevelData = datalist[i].data,rowspanum=0;  
					datalist[i].children = []; 
						if(onelevelData.controlEnterprise){
							for(var d=0;d<onelevelData.controlEnterprise.length;d++){
								let smdata=onelevelData.controlEnterprise[d];
								smdata.relationship="控制企业";
								datalist[i].children.push(smdata);
								rowspanum++;
							}
						}
					if(onelevelData.customer){
					for(var d=0;d<onelevelData.customer.length;d++){
						let smdata=onelevelData.customer[d];
						smdata.relationship="客户";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
					}
					if(onelevelData.invest){
					for(var d=0;d<onelevelData.invest.length;d++){
						let smdata=onelevelData.invest[d];
						smdata.relationship="对外投资";
						datalist[i].children.push(smdata);
						rowspanum++;
					}}
					if(onelevelData.shareholder){
					for(var d=0;d<onelevelData.shareholder.length;d++){
						let smdata=onelevelData.shareholder[d];
						smdata.relationship="股东";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
					}
					if(onelevelData.supplier){
					for(var d=0;d<onelevelData.supplier.length;d++){
						let smdata=onelevelData.supplier[d];
						smdata.relationship="供应商";
						datalist[i].children.push(smdata);
						rowspanum++;
					} 
					datalist[i].rowspanum = rowspanum; 
				}
				if(onelevelData.org){
					for(var d=0;d<onelevelData.org.length;d++){
						let smdata=onelevelData.org[d];
						smdata.relationship="投资机构";
						datalist[i].children.push(smdata);
						rowspanum++;
					} 
					datalist[i].rowspanum = rowspanum; 
				}
				if(onelevelData.commerce){
					for(var d=0;d<onelevelData.commerce.length;d++){
						let smdata=onelevelData.commerce[d];
						smdata.relationship="商会";
						datalist[i].children.push(smdata);
						rowspanum++;
					} 
					datalist[i].rowspanum = rowspanum; 
				}
				if(onelevelData.association){
					for(var d=0;d<onelevelData.association.length;d++){
						let smdata=onelevelData.association[d];
						smdata.relationship="协会";
						datalist[i].children.push(smdata);
						rowspanum++;
					} 
					datalist[i].rowspanum = rowspanum; 
				}
				}
				return datalist;
				
				
				
			},
			getDataName(datalist){
				for(var i=0;i<datalist.length;i++){
					var defautData={controlEnterprise:[],customer:[],invest:[],shareholder:[],supplier:[]};
					var onelevelData = datalist[i].data?datalist[i].data : defautData,rowspanum=0;  
					datalist[i].children = [];  
					if (onelevelData.controlEnterprise && onelevelData.controlEnterprise.length > 0) {
						datalist[i].children.push({
							relationship: "控制企业",
							list: onelevelData.controlEnterprise
						});
						rowspanum += onelevelData.controlEnterprise.length;
					}
					if (onelevelData.customer && onelevelData.customer.length > 0) {
						datalist[i].children.push({
							relationship: "客户",
							list: onelevelData.customer
						})
						rowspanum += onelevelData.customer.length;
					}
					if (onelevelData.invest && onelevelData.invest.length > 0) {
						datalist[i].children.push({
							relationship: "对外投资",
							list: onelevelData.invest
						})
						rowspanum += onelevelData.invest.length;
					}
					if (onelevelData.shareholder && onelevelData.shareholder.length > 0) {
						datalist[i].children.push({
							relationship: "股东",
							list: onelevelData.shareholder
						})
						rowspanum += onelevelData.shareholder.length;
					}
					if (onelevelData.supplier && onelevelData.supplier.length > 0) {
						datalist[i].children.push({
							relationship: "供应商",
							list: onelevelData.supplier,
						})
						rowspanum += onelevelData.supplier.length;
					}
					if (onelevelData.org && onelevelData.org.length > 0) {
						datalist[i].children.push({
							relationship: "投资机构",
							list: onelevelData.org,
						})
						rowspanum += onelevelData.org.length;
					}
					if (onelevelData.commerce && onelevelData.commerce.length > 0) {
						datalist[i].children.push({
							relationship: "商会",
							list: onelevelData.commerce,
						})
						rowspanum += onelevelData.commerce.length;
					}
					if (onelevelData.association && onelevelData.association.length > 0) {
						datalist[i].children.push({
							relationship: "协会",
							list: onelevelData.association,
						})
						rowspanum += onelevelData.association.length;
					}
					datalist[i].rowspanum = rowspanum; 
				}
				return datalist;
			},
	 
	 
		},
	}
</script>

<style scoped lang="scss">
	.user_tabtitle1{
	 height: 38px;line-height: 38px;margin-bottom: 32px;
	}
.user_tabtitle1 li{
	 width: calc(33% - 4px);text-align: center;cursor: pointer;  font-size: 16px;text-align: center;	border:1px solid #5E83CC;
	&.current,&:hover{
		background: #5E83CC;color: #fff; 
	}
}
.secondarylist li{
	width: 29%;height: 32px;line-height: 32px;margin-bottom: 20px;float: left;margin-right: 2%;margin-left: 1%;
}
.caculatBtn{
	background: #f8f8f8;color: #999;width: 80px;text-align: center;border-radius:6px;font-size: 15px;
	&.basebtn{
		background: #5E83CC;color: #fff;cursor: pointer;
	}
}
.secondaryEmptyText{
	text-align: center;height: 42px;line-height: 42px;background: #d4e0f8;margin-bottom: 30px;margin-top:30px;
}
.collectfont2 span{
	cursor: pointer;color:#5E83CC ;margin: 0 10px;font-size: 15px;
}
.opport-screen dt.long-font{
	width: 100px;margin-right: 20px;background-size:100% 100%;
}		
</style>
